import { SearchBar } from '@/components/dashboard/SearchBar';
import { useSearchParams } from 'react-router-dom';

export function ThreatIntelligence() {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const handleSearch = (query: string) => {
    if (query && query.length >= 2) {
      setSearchParams({ q: query });
    } else {
      setSearchParams({});
    }
  };

  return (
    <div className="space-y-6 pb-6">
      <SearchBar onSearch={handleSearch} initialQuery={searchParams.get('q') || ''} />
    </div>
  );
}